export default "__VITE_ASSET__CnMCNANY__"